import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { booksPath } from "../lib/paths";

const T = {
  de: {
    rotulo: "Unabhängiger Verlag · Oberösterreich",
    titulo: "Bücher, die im Dunkeln\nnicht loslassen.",
    entrada:
      "Erzählliteratur auf Spanisch und auf Deutsch. Wenige Titel im Jahr — und jeden einzelnen lektoriere, setze und gestalte ich selbst.",
    cta: "Die Bücher",
    cta2: "Über den Verlag",
    pie: "Burg Clam, Machland — Illustration aus «La uña izquierda de Dios»",
  },
  es: {
    rotulo: "Editorial independiente · Alta Austria",
    titulo: "Libros que no sueltan\ncuando cae la noche.",
    entrada:
      "Narrativa en español y en alemán. Pocos títulos al año, y cada uno lo corrijo, lo maqueto y lo diseño yo.",
    cta: "Los libros",
    cta2: "Sobre la editorial",
    pie: "Burg Clam, Machland — lámina de «La uña izquierda de Dios»",
  },
};

export default function Hero({ language = "de" }) {
  const t = T[language];

  return (
    <section className="relative overflow-hidden bg-tinta">
      <div className="absolute inset-0">
        <img
          src="/fondo-hero.jpg"
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover object-center opacity-[0.8]"
        />
        {/* Velo lateral: el texto se lee a la izquierda, el castillo respira a la derecha */}
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(18,16,14,0.94)_0%,rgba(18,16,14,0.90)_34%,rgba(18,16,14,0.55)_58%,rgba(18,16,14,0.25)_100%)]" />
        <div className="absolute inset-0 bg-gradient-to-b from-tinta/30 via-transparent to-tinta" />
      </div>

      <div className="relative mx-auto max-w-6xl px-5 sm:px-8 py-20 sm:py-28 lg:py-32">
        <div className="max-w-2xl">
          <motion.img
            src="/sello-bwv.png"
            alt="Sello del Blauer Wolf Verlag"
            width="96"
            height="96"
            className="w-20 h-20 sm:w-24 sm:h-24 mb-10 drop-shadow-[0_6px_22px_rgba(0,0,0,0.55)]"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7 }}
          />

          <motion.p
            className="rotulo text-loboClaro mb-6"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1, duration: 0.5 }}
          >
            {t.rotulo}
          </motion.p>

          <motion.h1
            className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.12] tracking-titulo text-luna mb-7"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.18, duration: 0.6 }}
          >
            {t.titulo.split("\n").map((l, i, a) => (
              <React.Fragment key={i}>
                {l}
                {i < a.length - 1 && <br />}
              </React.Fragment>
            ))}
          </motion.h1>

          <motion.p
            className="text-lg text-hueso/75 max-w-prosa mb-10"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.28, duration: 0.6 }}
          >
            {t.entrada}
          </motion.p>

          <motion.div
            className="flex flex-wrap items-center gap-5"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            <Link
              to={booksPath(language)}
              className="rotulo bg-hueso text-tinta px-7 py-3.5 hover:bg-luna transition-colors"
            >
              {t.cta}
            </Link>
            <Link
              to={`/${language}#verlag`}
              className="rotulo text-hueso/80 hover:text-hueso border-b border-lobo/50 hover:border-loboClaro pb-1 transition-colors"
            >
              {t.cta2}
            </Link>
          </motion.div>
        </div>
      </div>

      <p className="relative rotulo text-hueso/60 text-right mx-auto max-w-6xl px-5 sm:px-8 pb-5 -mt-4">
        {t.pie}
      </p>
    </section>
  );
}
